
<template>
  <div id="MyAssociationList">
    <div class="my-association-list-img">
      <img src="@/assets/schoolAffairs/community/st.png" />
    </div>
    <div id="MyAssociationInfo">
      <h1 class="my-association-name text-center" v-cloak><span>{{infoList.AssociationName}}</span></h1>
      <h3 class="my-association-description" v-cloak>{{infoList.Description}}</h3>
      <div class="my-association-leader" v-cloak>
        <p class="my-association-names">社长&nbsp;&nbsp;/&nbsp;&nbsp;President</p>
        <p class="my-association-user">{{infoList.Leader}}</p>
      </div>
      <div class="my-association-vice-leader">
        <p class="my-association-names">副社长&nbsp;&nbsp;/&nbsp;&nbsp;Vice President</p>
        <p v-if="infoList.ViceLeader!==null && infoList.ViceLeader.length>0" class="my-association-user">
          <span v-for="item in infoList.ViceLeader" v-bind:key="item.UserName" v-bind:title="item.UserName" style="margin-right:20px;" v-cloak>{{item.FullName}}</span>
        </p>
        <p v-else class="my-association-user">--</p>
      </div>
      <div class="my-association-leader-all clearfix">
        <p class="my-association-names">社员&nbsp;&nbsp;/&nbsp;&nbsp;Member</p>
        <ul v-if="infoList.Member!==null && infoList.Member.length>0" class="my-association-user my-association-users clearfix">
          <li v-cloak v-for="(info) of infoList.Member" v-bind:key="info.UserName">{{info.FullName}}</li>
        </ul>
        <p v-else>--</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      AssociationID: '',
      loading: false,//保存中状态
      infoList:
      {
        "Leader": "",
        "ViceLeader": [],
        "Member": [],
        "AssociationName": "",
        "Description": ""
      }

    };
  },
  computed: {
    apiPath () {
      return this.$store.state.apiPath
    }
  },
  created: function () {
    this.getRows();
  },
  methods: {
    // 获取上一页参数
    getRows: function () {
      this.AssociationID = this.$route.query.AssociationID
      if (this.AssociationID) {
        this.getMemberPage()
      }
    },
    getMemberPage: function () {
      let _this = this
      this.xyapi.get(`${this.apiPath}/api/MyAssociation/GetById`, { id: this.AssociationID }).then(res => {
        _this.infoList = res.data
      })
    }
  }
}
</script>
<style lang='less' scoped>
#MyAssociationList {
  img {
    width: 100%;
  }
  #MyAssociationInfo {
    div {
      margin-bottom: 40px;
    }
    background-color: #fff;
    margin-top: 40px;
    border-style: solid;
    border-color: #eee;
    border-width: 1px 0px;
    padding: 32px;
    .my-association-name {
      font-size: 48px;
      font-weight: 700;
    }
    .my-association-description {
      margin: 40px 0px;
      font-size: 28px;
      color: #7f7f7f;
    }
    .my-association-users {
      li {
        display: inline-block;
        margin: 0px 40px 40px 0px;
        width: 106px;
        word-wrap: break-word;
        word-break: normal;
        word-break: break-all;
        font-size: 24px;
      }
    }
  }
}
.my-association-names {
  font-size: 36px;
  margin-bottom: 20px;
  font-weight: 700;
}
.my-association-user {
  font-size: 32px;
}
</style>